import React from 'react'
import {School} from "@mui/icons-material";
import {FactCheck, Science} from "@mui/icons-material";

const DifficultyIndication = ({feedbackMode}) => {
    if (feedbackMode === 'standard') {
        return <School style={{height: 35, width: 35, color: "grey"}}/>
    }

    if (feedbackMode === 'lab') {
        return <Science style={{height: 35, width: 35, color: "grey"}}/>
    }

    if(feedbackMode === 'exam') {
        return <FactCheck style={{height: 35, width: 35, color: "grey"}}/>
    }

    return ''
}
export default DifficultyIndication
